/** French dictionary. */
const fr = {
  nav: {
    dashboard: 'Tableau de bord',
    products: 'Produits',
    website: 'Site web',
    advertorials: 'Publireportages',
    ads: 'Publicités',
    splitTesting: 'Tests A/B',
    findUpsells: 'Trouver des upsells',
    findProducts: 'Trouver des produits',
    aiChat: 'Chat IA',
    referAndEarn: 'Parrainer et gagner',
    settings: 'Paramètres',
    notifications: 'Notifications',
    aiSuggestions: 'Suggestions IA',
    noSuggestions: 'Pas encore de suggestions — revenez bientôt !',
    caughtUp: 'Vous êtes à jour',
    noNotificationsBody: 'Nous vous préviendrons ici quand une création sera terminée ou que l’IA aura une suggestion pour votre boutique.',
    groups: {
      create: 'Créer',
      grow: 'Développer',
      assistant: 'Assistant',
      account: 'Compte',
    },
  },
  common: {
    generate: 'Générer',
    publish: 'Publier',
    download: 'Télécharger',
    downloadAll: 'Tout télécharger',
    save: 'Enregistrer',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    continue: 'Continuer',
    done: 'Terminé',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    close: 'Fermer',
    loading: 'Chargement...',
    loadingStore: 'Chargement de votre boutique…',
    product: 'Produit',
    selectProduct: 'Sélectionnez un produit',
    pleaseChooseProduct: 'Veuillez choisir un produit',
    markComplete: 'Marquer comme terminé',
    copyHtml: 'Copier le HTML',
    settingsSaved: 'Paramètres enregistrés',
    alreadyGenerating: 'Une génération est déjà en cours — consultez l\u2019indicateur de progression en bas à droite.',
    generationStarted: 'Génération lancée — vous pouvez quitter cette page, nous vous préviendrons quand ce sera prêt.',
    open: 'Ouvrir',
    tryAgain: 'Réessayer',
    viewLive: 'Voir la page en ligne',
    preview: 'Aperçu',
  },
  dashboard: {
    suggestions: 'Suggestions IA',
    dismiss: 'Ignorer',
    adPerformance: 'Performance publicitaire — 30 derniers jours',
    badgeNew: 'Nouveau',
    badgeComingSoon: 'Bientôt',
    metrics: {
      totalSpend: 'Dépense totale',
      roas: 'ROAS',
      purchases: 'Achats',
      revenue: 'Revenu',
      clicks: 'Clics',
      ctr: 'CTR',
    },
    capabilities: {
      buildProducts: {
        title: 'Créez des produits de zéro',
        desc: 'Téléversez une photo ou collez une URL — l\u2019IA crée le produit complet, les images, les prix et une page produit à forte conversion.',
      },
      fullWebsite: {
        title: 'Créez un site web complet',
        desc: 'Accueil, à propos, contact — une boutique complète à votre image autour de votre produit.',
      },
      imageAds: {
        title: 'Publicités image',
        desc: '20 créations publicitaires DTC professionnelles par produit, prêtes pour Meta.',
      },
      videoAds: {
        title: 'Publicités vidéo',
        desc: 'Des publicités vidéo générées par IA qui convertissent sur Meta et TikTok.',
      },
      advertorials: {
        title: 'Publireportages',
        desc: 'Des articles au style éditorial qui vendent — récit, recherche, liste et plus.',
      },
      releaseAds: {
        title: 'Créez et lancez des publicités',
        desc: 'L\u2019IA rédige le texte, monte la campagne et la publie sur votre compte Meta.',
      },
      splitTesting: {
        title: 'Tests A/B',
        desc: 'Testez prix, offres, images, textes et pages pour trouver ce qui gagne.',
      },
      scaling: {
        title: 'Suggestions de scaling',
        desc: 'L\u2019IA suit les publicités gagnantes et vous dit exactement quoi scaler et quand.',
      },
      winningAds: {
        title: 'Détection des publicités gagnantes',
        desc: 'L\u2019IA trouve vos meilleures publicités et en crée d\u2019autres à partir de ce qui marche.',
      },
      aiAssistant: {
        title: 'Assistant IA',
        desc: 'Demandez-lui tout — changer un prix, corriger une page, lancer un test, scaler une pub.',
      },
      themeEditorAi: {
        title: 'Autonoma IA dans l’éditeur de thème',
        desc: 'Cliquez sur une section dans l’éditeur de thème Shopify et dites à l’IA quoi changer, sur n’importe quel thème.',
      },
      mobileApp: {
        title: 'Gérez depuis votre téléphone',
        desc: 'Pilotez votre boutique et lancez des publicités où que vous soyez depuis l\u2019app mobile.',
      },
    },
    mobileAppModal: {
      title: 'Téléchargez l\u2019app Autonoma sur votre téléphone',
      subtitle: 'Copiez le lien et ouvrez-le sur votre appareil — ou ouvrez la boutique directement.',
      ios: 'iOS — App Store',
      android: 'Android — Google Play',
      open: 'Ouvrir',
      copyLink: 'Copier le lien',
      copied: 'Copié',
      close: 'Fermer',
    },
    title: 'Tableau de bord',
    subtitle: 'Créez des produits, des pages, des publicités et des sites web, puis laissez l’IA continuer à les améliorer.',
    primaryAction: 'Créer un produit',
    capabilitiesTitle: 'Tout ce qu’Autonoma peut faire',
    capabilitiesSubtitle: 'Choisissez un outil pour commencer. Les fonctions marquées « Automatique » tournent seules dès que vos publicités ont des données.',
    automatic: 'Automatique',
    automaticHint: 'Tourne seule dès que vos publicités ont des données — rien à configurer.',
    gettingStarted: {
      title: 'Premiers pas',
      progress: '{done} sur {total} terminés — l’étape suivante est mise en avant.',
      hide: 'Masquer',
      doneCta: 'Terminé',
      product: {
        title: 'Créez un produit',
        desc: 'Téléversez une photo — nous créons le produit, les images et la page.',
        cta: 'Créer un produit',
      },
      ads: {
        title: 'Créez des publicités',
        desc: 'Publicités image, publicités vidéo et textes publicitaires pour votre produit.',
        cta: 'Créer des publicités',
      },
      meta: {
        title: 'Connectez Meta et lancez',
        desc: 'Connectez votre compte publicitaire, puis publiez une campagne.',
        cta: 'Connecter Meta',
      },
      website: {
        title: 'Créez un site web',
        desc: 'Une boutique complète à votre image autour de vos produits.',
        cta: 'Créer un site web',
      },
    },
  },
  ads: {
    imageN: 'Image {n}',
    brief: {
      label: 'Brief', open: 'Voir le brief de l’image', title: 'Brief de l’image', close: 'Fermer',
      layout: 'Mise en page', purpose: 'Objectif', attempts: '{n} tentatives', textRendered: 'Texte composé par nous', compositeUsed: 'Vrai produit intégré',
      pass: 'validé', fail: 'échec', gateIdentity: 'Identité', gateText: 'Texte', gateAesthetics: 'Esthétique', gateArrows: 'Flèches',
      overlays: 'Texte sur l’image (exact)', camera: 'Caméra', lighting: 'Éclairage', background: 'Arrière-plan', negativeSpace: 'Espace libre',
      finalPrompt: 'Prompt final', copy: 'Copier', copied: 'Copié',
    },
    title: 'Publicités',
    subtitle: 'Créez, vérifiez et publiez des publicités Meta — étape par étape',
    tabCreate: 'Créer',
    tabInProgress: 'En cours',
    tabCompleted: 'Terminées',
    tabStrategy: 'Stratégie',
    stepSetup: 'Configuration',
    stepCreatives: 'Créations',
    stepCopy: 'Texte',
    stepPublish: 'Publier',
    generateAds: 'Générer les publicités',
    clickToSelect: 'Cliquez sur les images pour les sélectionner.',
    campaignSetup: 'Configuration de la campagne',
    campaignName: 'Nom de la campagne',
    adSetName: 'Nom de l\u2019ensemble de publicités',
    dailyBudget: 'Budget quotidien',
    countries: 'Pays',
    publishAds: 'Publier les publicités',
    connectAdAccount: 'Connecter le compte publicitaire',
    setup: {
      account: {
        title: 'Connectez votre compte publicitaire Meta pour publier',
        body: 'Vos publicités sont prêtes. La publication nécessite un compte publicitaire Meta connecté — une minute dans les Paramètres, puis revenez ici.',
        cta: 'Connecter le compte publicitaire',
      },
      page: {
        title: 'Sélectionnez une Page Facebook pour publier',
        body: 'Meta a besoin d’une Page Facebook pour créer les visuels publicitaires. Choisissez-en une dans les Paramètres, puis revenez ici.',
        cta: 'Sélectionner une Page Facebook',
      },
      pixel: {
        title: 'Configurez votre pixel Meta pour publier',
        body: 'Les publicités optimisées pour l’achat nécessitent votre pixel avec l’événement Achat. Configurez-le dans les Paramètres, puis revenez ici.',
        cta: 'Configurer le pixel',
      },
    },
    connectToPublish: 'Veuillez connecter votre compte publicitaire pour publier.',
    adCopy: 'Texte publicitaire',
    generateCopy: 'Générer le texte',
    useExistingCopy: 'Utiliser un texte existant',
    noInProgress: 'Aucune publicité en cours. Commencez-en une depuis l\u2019onglet Créer — votre progression est enregistrée automatiquement à chaque étape.',
    noCompleted: 'Pas encore de campagnes terminées.',
    createNewAds: 'Créer de nouvelles publicités',
    imageAds: 'Publicités image',
    videoAds: 'Publicités vidéo',
    writeManually: 'Rédiger manuellement',
    manualCopyTitle: 'Rédigez votre propre texte publicitaire',
    manualCopyHelp: 'Le premier texte principal et le premier titre sont obligatoires — les autres sont facultatifs mais recommandés pour que Meta teste plus de variantes.',
    primaryText: 'Texte principal',
    headline: 'Titre',
    required: 'obligatoire',
    recommended: 'recommandé',
    manualValidation: 'Ajoutez au moins le premier texte principal et le premier titre pour continuer.',
    emptyInProgressTitle: 'Rien en cours',
    emptyCompletedTitle: 'Aucune création de publicités terminée pour l’instant',
    emptyCompletedBody: 'Les créations terminées s’affichent ici en lecture seule — lancez-en une depuis Créer.',
    progressTitle: 'Création de vos publicités',
    progressSteps: {
      study: 'Étude des photos de votre produit',
      design: 'Conception de vos visuels',
      render: 'Génération de vos images',
      renderVideo: 'Génération de vos images et vidéos',
      review: 'Préparation pour la relecture',
    },
    cancelGeneration: 'Annuler cette création',
    cancelConfirm: 'Annuler cette création ?',
    cancelTitle: 'Annuler la création',
    liveTitle: 'Votre campagne est en ligne 🚀',
    liveBody: '{n} publicité(s) diffusée(s), dépensant votre budget quotidien.',
    pausedTitle: 'Votre campagne est créée — elle est désactivée 🎉',
    pausedBody: 'Rien n’est encore dépensé. Activez-la quand vous êtes prêt, ou vérifiez-la d’abord dans Meta.',
    viewInAdsManager: 'Voir dans le Gestionnaire de publicités',
    createMore: 'Créer d’autres publicités',
    turnOnTitle: 'Activer la campagne',
    turnOnDesc: 'Commence à dépenser votre budget quotidien immédiatement.',
    turnOn: 'Activer',
    reviewInMetaTitle: 'La vérifier d’abord dans Meta',
    reviewInMetaDesc: 'Vérifiez les publicités, l’audience et le budget dans le Gestionnaire de publicités avant de dépenser.',
    barTitle: 'Publier {n} publicité(s) sur Meta',
    barActive: 'Elles seront diffusées dès leur publication.',
    barPaused: 'Elles sont créées désactivées — rien n’est dépensé tant que vous ne les activez pas.',
    next: {
      performance: {
        title: 'Suivez les résultats',
        desc: 'Dépenses, ROAS et achats apparaissent sur votre tableau de bord dès que Meta remonte les données.',
        cta: 'Aller au tableau de bord',
      },
      split: {
        title: 'Testez la page d’atterrissage en A/B',
        desc: 'Testez prix, offres et versions de page pour améliorer la conversion.',
        cta: 'Lancer un test A/B',
      },
    },
  },
  advertorials: {
    title: 'Publireportages',
    subtitle: 'Générez des pages éditoriales longues qui se lisent comme des articles de presse et vendent vos produits',
    generate: 'Générer le publireportage',
    publish: 'Publier le publireportage',
    published: 'Publireportage publié !',
    createAdsQuestion: 'Créer des publicités sur cet angle ?',
    yesCreateAds: 'Oui, créer des publicités',
    noThanks: 'Non merci',
    tabCreate: 'Créer',
    tabPrevious: 'Déjà créés',
    allProducts: 'Tous les produits',
    filterByProduct: 'Filtrer par produit',
    noPrevious: 'Pas encore de publireportages — créez le premier depuis l\u2019onglet Créer.',
    editWithAi: 'Ouvrir et modifier avec l\u2019IA',
    createAdsFor: 'Créer des publicités pour l\u2019advertorial',
    viewLive: 'Voir la page en ligne',
    updated: 'Publireportage mis à jour !',
    created: 'Créé',
    setupEyebrow: 'Configuration',
    setupTitle: 'Choisissez un produit et un style',
    startError: 'Impossible de lancer le publireportage',
    progressTitle: 'Rédaction de votre publireportage',
    progressSteps: {
      research: 'Recherche sur le produit et l’audience',
      write: 'Rédaction de l’article',
      images: 'Création des images',
      layout: 'Mise en page',
    },
    reviewEyebrow: 'Relecture',
    reviewTitle: 'Votre publireportage',
    reviewHint: 'Relisez-le, cliquez sur n’importe quel élément pour le modifier, puis publiez quand il vous convient.',
    draftLabel: 'Brouillon — pas encore en ligne',
    publishError: 'Impossible de publier le publireportage',
    liveTitle: 'Votre publireportage est en ligne 🎉',
    editInThemeEditor: 'Modifier dans l’éditeur de thème',
    createAnother: 'Créer un autre publireportage',
    emptyTitle: 'Aucun publireportage pour l’instant',
    next: {
      ads: {
        title: 'Créez des publicités sur cet angle',
        desc: 'Des publicités qui mènent à votre publireportage — mêmes étapes : visuels → texte → publication.',
      },
      edit: {
        title: 'Voir tous vos publireportages',
        desc: 'Ouvrez, modifiez avec l’IA ou créez des publicités pour n’importe quel publireportage précédent.',
        cta: 'Tout voir',
      },
    },
  },
  products: {
    title: 'Produits',
    subtitle: 'Tout ce qu\u2019Autonoma a créé ou qui vit dans votre boutique',
    createNew: 'Créer un nouveau produit',
    createImages: 'Créer des images',
    createPage: 'Créer une page produit',
    loading: 'Chargement de vos produits…',
    loadError: 'Impossible de charger vos produits',
    emptyTitle: 'Aucun produit pour l’instant',
    emptyBody: 'Créez votre premier produit — téléversez une photo et nous créons le produit, les images et la page.',
    statusActive: 'Actif',
    statusDraft: 'Brouillon',
  },
  newProduct: {
    addPhotos: 'Ajouter des photos du produit',
    variantName: 'Nom de la variante',
    variantNameN: 'Nom de la variante {n}',
    title: 'Nouveau produit',
    subtitle: 'Téléversez vos photos produit (URL facultative) — Autonoma crée le produit et la page',
    startError: 'Impossible de lancer la création',
    barTitle: 'Quand vous voulez',
    barReady: 'Nous créons le produit, les images et la page — environ 5 minutes.',
    barNeedPhoto: 'Téléversez au moins une photo du produit pour commencer.',
    starting: 'Lancement…',
    generateOne: 'Générer le produit + la page',
    generateMany: 'Générer {n} produits + pages',
    progressTitle: 'Création de votre produit et de votre page',
    progressSteps: {
      read: 'Lecture de vos photos et de vos notes',
      write: 'Rédaction de votre produit et de votre page',
      images: 'Création des images produit',
      shopify: 'Mise en place dans Shopify',
    },
    cancelBuild: 'Annuler cette création',
    cancelConfirm: 'Annuler cette création ?',
    cancelTitle: 'Annuler la création',
    cancelIt: 'Annuler',
    previewError: 'Impossible de charger l’aperçu de la page',
    loadingPreview: 'Chargement de l’aperçu de votre page…',
    sections: {
      photos: 'Photos',
      source: 'Source · facultatif',
      details: 'Détails · facultatif',
      style: 'Style de page',
    },
  },
  createImages: {
    settingsSummary: '{product} · {n} images dans ce lot',
    newBatch: 'Nouveau lot',
    title: 'Créer des images produit',
    subtitle: 'De nouvelles photos produit par IA à partir de vos clichés existants',
    progressTitle: 'Création de {n} images…',
    progressSteps: {
      study: 'Étude de votre produit…',
      design: 'Préparation de chaque prise de vue…',
      render: 'Génération des images…',
      finish: 'Dernières retouches…',
    },
    cancelConfirm: 'Annuler la création de ces images ?',
    cancelTitle: 'Annuler les images',
    publishedTitle: '{n} images publiées sur votre produit 🎉',
    publishedBody: 'La première est désormais l’image principale du produit.',
    nextAds: 'Créer des publicités avec ces images',
    barTitle: 'Images produit',
    barSelected: '{n} sur {total} sélectionnées',
    downloadSelected: 'Télécharger les {n} sélectionnées',
    downloadAll: 'Tout télécharger',
    publishN: 'Publier {n} sur la page produit',
  },
  createPage: {
    title: 'Créer une page produit',
    subtitle: 'Une page produit à forte conversion pour un produit existant',
    progressTitle: 'Création de votre page produit…',
    progressPreview: 'Préparation de l’aperçu…',
    alreadyGenerating: 'Une page est déjà en cours de création pour ce produit — suivez sa progression dans l’indicateur en bas à droite.',
  },
  upsell: {
    title: 'Découverte d\u2019upsells',
    subtitle: 'Trouvez les produits complémentaires que vos concurrents vendent avec les vôtres — le moyen le plus rapide d\u2019augmenter le panier moyen',
    flowPick: 'Choisir un upsell',
    previewTitle: 'Aperçu de votre upsell',
    publishedTitle: 'Upsell publié',
    previewSubtitle: '« {upsell} » en option complémentaire de « {main} »',
    liveTitle: 'Votre upsell est en ligne 🎉',
    liveBody: 'Il apparaît en option complémentaire à côté d’Ajouter au panier sur « {main} ». Les clients qui le cochent reçoivent les deux articles ensemble dans leur panier.',
    liveBodyNoBlock: 'Le produit d’upsell et sa page sont en ligne. Le bloc d’option complémentaire demande une étape manuelle — voir ci-dessous.',
    blockManualTitle: 'Ajoutez le bloc d’option complémentaire à votre page produit',
    viewMainPage: 'Voir la page produit',
    viewUpsellPage: 'Voir la page de l’upsell',
    nothingLiveTitle: 'Rien n’est encore en ligne',
    nothingLiveBody: 'Relisez les deux éléments ci-dessous et affinez-les jusqu’à satisfaction, puis publiez. La publication active le produit d’upsell, met sa page en ligne et ajoute le bloc d’option complémentaire à côté d’Ajouter au panier sur « {main} ».',
    barLive: 'En ligne sur votre boutique',
    barDraft: 'Brouillon — publiez les deux éléments en un clic',
    publishError: 'Impossible de publier l’upsell',
    publishAll: 'Publier l’upsell',
    republish: 'Republier',
    discoverProgressTitle: 'Recherche d’upsells',
    discoverSteps: {
      scan: 'Analyse de votre catalogue',
      research: 'Recherche des bonnes associations',
      rank: 'Classement des meilleures correspondances',
    },
    buildProgressTitle: 'Création de « {name} »',
    yourUpsell: 'votre upsell',
    buildSteps: {
      product: 'Création du produit d’upsell',
      page: 'Rédaction de sa page produit',
      block: 'Conception du bloc d’option complémentaire',
    },
    noneTitle: 'Aucune recommandation n’a été trouvée',
    noneBody: 'Cela arrive de temps en temps — réessayez dans un instant.',
    next: {
      ads: {
        title: 'Créer des publicités pour le produit principal',
        desc: 'Envoyez du trafic vers la page qui porte désormais l’upsell.',
        cta: 'Créer des publicités',
      },
      another: {
        title: 'Trouver un autre upsell',
        desc: 'Ajoutez d’autres options complémentaires à d’autres produits.',
        cta: 'Trouver des upsells',
      },
    },
  },
  splitTesting: {
    metrics: {
      variant: 'Chaque version testée',
      split: 'Part des visiteurs qui voient cette version',
      sessions: 'Visites de cette version',
      purchases: 'Commandes issues de cette version',
      revenue: 'Ventes de cette version',
      cvr: 'Taux de conversion — commandes ÷ visites',
      aov: 'Panier moyen — revenu ÷ commandes',
      roas: 'Retour sur dépenses publicitaires — revenu ÷ dépenses pub',
      rpv: 'Revenu par visiteur — revenu ÷ visites',
      legendProb: 'P(best) = probabilité que cette version soit la meilleure',
      legend: 'CVR = taux de conversion · AOV = panier moyen · ROAS = retour sur dépenses publicitaires · ★ = objectif de ce test',
    },
    title: 'Tests A/B',
    subtitle: 'Testez prix, pages et offres — trouvez ce qui convertit le mieux',
    tabs: {
      create: 'Créer',
      active: 'Actifs',
      paused: 'En pause',
      completed: 'Terminés',
    },
    flow: {
      type: 'Type de test',
      setup: 'Configurer',
      launch: 'Aperçu et lancement',
    },
    pickProduct: 'Choisissez un produit',
    whatToTest: 'Que voulez-vous tester ?',
    previewVariants: 'Aperçu de vos variantes',
    progressTitle: 'Création de vos variantes…',
    progressSteps: {
      read: 'Lecture de votre page actuelle…',
      write: 'Rédaction de chaque variante…',
      images: 'Création des images…',
      preview: 'Préparation des aperçus…',
    },
    cancelBuild: 'Annuler cette création',
    cancelConfirm: 'Annuler la création de ces variantes ?',
    cancelTitle: 'Annuler la création',
    buildFailedTitle: 'Nous n’avons pas pu créer les variantes',
    buildFailedHint: 'Ajustez les descriptions des variantes ci-dessus et réessayez.',
    runningTitle: 'Votre test est en cours 🎉',
    runningBody: 'Le trafic est maintenant réparti entre vos variantes. Les résultats se mettent à jour en direct à mesure que les visiteurs arrivent.',
    viewResults: 'Voir les résultats',
    viewActive: 'Voir les tests actifs',
    createTest: 'Créer un test',
    emptyActiveTitle: 'Aucun test actif',
    emptyActiveBody: 'Tester en continu, c’est ainsi que les boutiques grandissent — commencez par un test de prix ou d’offre.',
    emptyPausedTitle: 'Aucun test en pause',
    emptyPausedBody: 'Mettre un test en pause arrête la répartition du trafic et la collecte de données — reprenez-le à tout moment là où il s’était arrêté.',
    parity: {
      blockedTitle: 'Ce produit ne peut pas faire l’objet d’un test avec produit variante',
      warnTitle: 'Attention : des apps sont liées à ce produit',
      warnFooter: 'Les tests de prix, d’image, d’offre et de bundle envoient le groupe B vers un produit variante. Le stock, le profil d’expédition et les réductions restent synchronisés automatiquement pendant tout le test ; les éléments ci-dessus dépendent de l’identifiant produit et peuvent ne pas suivre. Les tests de page produit sur vos propres URL ne sont pas concernés.',
    },
    storefront: {
      pauseAll: 'Mettre tous les tests en pause ({n})',
      pauseAllHint: 'Arrêt d’urgence : met en pause tous les tests en cours et désactive le script de la boutique. Les acheteurs retrouvent vos pages normales en moins de 60 secondes.',
      deliveryTitle: 'Vos tests n’atteignent pas encore les acheteurs',
      deliveryBody: 'Cette boutique n’a ni l’ancien script tag Autonoma ni l’app embed Autonoma AI activé : aucun acheteur n’est donc affecté à un test (Shopify n’accepte plus de nouveaux script tags depuis le 1er oct. 2026). Activez l’app embed dans l’éditeur de thème et cliquez sur Enregistrer — moins d’une minute.',
      deliveryEnable: 'Activer l’app embed',
      pauseAllConfirm: 'Mettre en pause tous les tests en cours et désactiver le script de split testing de cette boutique ? Les acheteurs verront vos pages normales en moins de 60 secondes. Vous pourrez reprendre les tests ensuite.',
      pausedAllNotice: '{n} test(s) mis en pause et script de la boutique désactivé. Les acheteurs retrouvent vos pages normales en moins de 60 secondes.',
      offTitle: 'Les split tests sont DÉSACTIVÉS sur votre boutique',
      offBody: 'Tant qu’ils sont désactivés, aucun visiteur n’est redirigé, rien n’est masqué et aucun panier n’est touché — les affectations existantes sont ignorées.',
      offPauseAll: 'Vous avez mis tous les tests en pause le {since}.',
      offManual: 'Le script de la boutique a été désactivé le {since}.',
      offParity: 'Autonoma a désactivé le script de la boutique le {since} car un produit variante ne correspondait plus à l’original (voir le test en pause).',
      offGlobal: 'L’équipe Autonoma a désactivé les split tests pour toutes les boutiques le temps d’examiner un problème.',
      turnOn: 'Réactiver les split tests sur la boutique',
      errorTitle: 'Cela n’a pas fonctionné',
    },
    emptyCompletedTitle: 'Aucun test terminé pour l’instant',
    emptyCompletedBody: 'Les résultats arrivent ici dès qu’un test atteint son seuil de données ou que vous y mettez fin.',
  },
  website: {
    title: 'Créateur de site web',
    subtitle: 'Créez une boutique multi-produits — accueil, navigation, logo, nom d\u2019entreprise, politiques et image de marque au checkout — autour de vos produits sélectionnés',
    startError: 'Impossible de lancer la création du site',
    previousTitle: 'Sites précédents',
    previousEmpty: 'Pas encore de site — créez le premier ci-dessous.',
    productsError: 'Impossible de charger vos produits',
    searchProducts: 'Rechercher des produits',
    selectAll: 'Tout sélectionner',
    clear: 'Effacer',
    selectedCount: '{n} sur {total} sélectionnés',
    noMatches: 'Aucun produit ne correspond à cette recherche.',
    showAll: 'Afficher les {n} produits',
    showFewer: 'En afficher moins',
    barTitle: 'Prêt à créer',
    barNoProducts: 'Créez d’abord un produit.',
    barPickProducts: 'Sélectionnez au moins un produit ci-dessus.',
    barTitlePending: 'Presque prêt',
    barNeedName: 'Ajoutez un nom d’entreprise ou cochez « Laisser l’IA créer le nom de mon entreprise ».',
    barReady: 'Création autour de {n} produit(s) — environ 5 minutes.',
    buildCta: 'Créer mon site web',
    progressTitle: 'Création de votre site web',
    progressSteps: {
      brand: 'Définition du nom, des couleurs et du logo de votre marque',
      homepage: 'Rédaction de votre page d’accueil',
      images: 'Création des images du site',
      pages: 'Mise en place des pages, menus et collections',
    },
    cancelBuild: 'Annuler cette création',
    cancelConfirm: 'Annuler la création de ce site ?',
    cancelTitle: 'Annuler la création du site',
    liveTitle: 'Votre site web est en ligne 🎉',
    liveBody: 'La page d’accueil, les pages À propos et Contact, les politiques, les menus et les collections sont désormais en ligne sur votre boutique.',
    viewStorefront: 'Voir la boutique en ligne',
    openAbout: 'Ouvrir la page À propos',
    refineHomepage: 'Affiner la page d’accueil',
    buildAnother: 'Créer un autre site',
    previewReadyTitle: 'L’aperçu de votre site est prêt',
    previewReadyBody: 'Rien n’est encore en ligne. Vérifiez l’aperçu ci-dessous, décrivez les changements souhaités, puis publiez pour mettre tout le site en ligne — pages, politiques, menus et collections compris.',
    logo: {
      eyebrow: 'Votre logo',
      title: 'Logo de la marque',
      dims: 'PNG transparent {w}×{h}',
      sourceGenerated: 'Généré pour {name}',
      sourceUploaded: 'Votre logo importé',
      sourceTheme: 'Le logo actuel de votre thème',
      sourceBrand: 'Votre logo Marque Shopify',
      download: 'Télécharger le PNG (280×80)',
      generateAnother: 'En générer un autre',
      uploadOwn: 'Importer le mien',
      undo: 'Annuler — restaurer l’ancien logo',
      generating: 'Création d’un autre logo…',
      uploading: 'Import de votre logo…',
      setInTheme: 'Défini dans le thème « {theme} » — {where}',
      whereGlobal: 'paramètres du thème (sélecteur d’image du logo)',
      whereHeader: 'section d’en-tête (sélecteur d’image du logo)',
      whereBoth: 'paramètres du thème + section d’en-tête',
      keptCurrent: 'Votre logo actuel a été conservé : rien n’a été remplacé dans le thème.',
      notApplied: 'Pas encore défini dans le thème',
      noLogoSetting: 'Ce thème n’a pas de paramètre d’image de logo : téléchargez le PNG et importez-le dans l’éditeur de thème.',
      willApply: 'Publiez le site pour le définir dans l’en-tête de votre thème (140 px de large).',
      restored: 'Ancien logo restauré dans le thème.',
      failed: 'L’action sur le logo a échoué',
      choiceTitle: 'Logo',
      choiceHelp: 'Vous avez déjà un logo. Gardez-le, ou laissez l’IA en concevoir un nouveau (PNG transparent 280×80).',
      useCurrent: 'Utiliser mon logo actuel',
      generateNew: 'Générer un nouveau logo',
      currentFrom: 'Trouvé dans : {where}',
      currentTheme: 'votre thème',
      currentBrand: 'les paramètres Marque de Shopify',
    },
    openPreview: 'Ouvrir l’aperçu et publier',
    barDraft: 'Aperçu — pas encore en ligne',
    pages: {
      home: 'Accueil',
      about: 'À propos',
      contact: 'Contact',
      aboutDesc: 'La page À propos est rédigée à partir de l’histoire de la marque et créée sur votre boutique à la publication du site.',
      contactDesc: 'Une page Contact avec un formulaire fonctionnel est créée sur votre boutique à la publication du site.',
    },
    next: {
      ads: {
        title: 'Créez des publicités pour vos produits',
        desc: 'Publicités image, publicités vidéo et textes publicitaires, prêts à lancer sur Meta.',
        cta: 'Créer des publicités',
      },
      split: {
        title: 'Testez vos pages en A/B',
        desc: 'Testez prix, offres et versions de page pour découvrir ce qui vend.',
        cta: 'Lancer un test A/B',
      },
    },
  },
  chat: {
    title: 'Chat IA',
    subtitle: 'Modifiez votre boutique, vos produits et vos publicités en le demandant simplement',
    placeholder: 'Demandez à Autonoma tout ce que vous voulez pour développer votre boutique...',
    send: 'Envoyer',
    publishFailed: 'Impossible de publier le texte publicitaire',
  },
  settings: {
    title: 'Paramètres',
    subtitle: 'Gérez votre boutique, compte publicitaire, valeurs par défaut et forfait',
    language: 'Langue de l\u2019application',
    languageHelp: 'Détectée automatiquement depuis votre admin Shopify — changez-la ici si vous préférez. Change la langue de l\u2019application ET la langue de tout le contenu généré par IA (publicités, pages, publireportages, voix off des vidéos).',
    languageSaved: 'Langue mise à jour',
    dataSharingTitle: 'Statistiques anonymisées',
    dataSharingLabel: "Partagez des statistiques d'utilisation anonymisées et agrégées pour aider à améliorer Autonoma.",
    dataSharingHelp: "Activé par défaut (vous pouvez le désactiver à tout moment dans les Paramètres). Une fois activé, des tendances anonymisées et agrégées sur les publicités, pages et offres qui convertissent améliorent les recommandations de l'IA pour toutes les boutiques. Aucune donnée personnelle n'est jamais partagée — ni vos données clients, ni vos noms de produits, ni vos chiffres de vente, ni l'identité de votre boutique.",
    autoImproveTitle: 'Amélioration automatique',
    autoImproveLabel: 'Suggérer un test A/B lorsqu\'une page a assez de trafic et un faible taux d\'ajout au panier.',
    autoImproveHelp: 'Désactivé tant que vous ne l\'activez pas. Autonoma mesure la façon dont les visiteurs parcourent les sections des pages qu\'il a créées (quelles sections sont vues, combien de temps, et où se produit l\'ajout au panier — jamais qui est le visiteur) et, une fois activé, suggère un test A/B du hero ou de l\'offre par page sous forme de notification. Vous validez chaque variante avant toute répartition du trafic ; rien ne démarre tout seul.',
    autoImproveStats: '{views} vues sur {pages} pages Autonoma au cours des {days} derniers jours · suggestions à partir de {min} vues par page.',
    autoImproveNoData: 'Aucune vue mesurée pour l\'instant — les pages créées avec la bibliothèque de sections actuelle commencent à remonter des données dès que des visiteurs les consultent.',
    onThisPage: 'Sur cette page',
    saveFailed: 'Enregistrement impossible',
    metaConnectError: 'Impossible de connecter votre compte Meta',
    sections: {
      plan: 'Forfait et utilisation',
      meta: 'Compte Meta Ads',
      defaults: 'Réglages publicitaires par défaut',
      themeEditor: 'Éditeur de thème',
      mobile: 'Application mobile',
      referrals: 'Parrainage',
      privacy: 'Confidentialité',
    },
  },
  plans: {
    title: 'Choisissez votre forfait',
    subtitle: '{plans} incluent {n} jours d’essai gratuit. Annulez à tout moment.',
    subtitleNoTrial: 'Annulez à tout moment.',
    andPlans: 'et',
    perMonth: '/mois',
    trialChip: '{n} jours d’essai gratuit',
    billedToday: 'Facturé aujourd’hui',
    mostPopular: 'Le plus populaire',
    startTrial: 'Commencer l’essai gratuit',
    choose: 'Choisir {name}',
    opening: 'Ouverture de Shopify…',
    loading: 'Chargement des forfaits',
    loadError: 'Impossible de charger les forfaits — actualisez la page.',
    declined: 'Vous devez accepter un forfait pour continuer — choisissez-en un ci-dessous.',
    unverified: 'Nous n’avons pas encore pu confirmer votre abonnement auprès de Shopify. Si vous avez approuvé le paiement, cliquez sur « Vérifier à nouveau » ; sinon choisissez un forfait ci-dessous.',
    checkAgain: 'Vérifier à nouveau',
    checking: 'Vérification…',
    contactSupport: 'Contacter le support',
    reactivateTitle: 'Votre abonnement est inactif',
    reactivateSubtitle: 'Réactivez-le pour restaurer vos pages, produits et publicités — rien n’est supprimé.',
    reactivateReason: {
      cancelled: 'Votre abonnement Autonoma a été annulé.',
      frozen: 'Votre abonnement est gelé — Shopify n’a pas pu prélever le dernier paiement.',
      declined: 'Le paiement de l’abonnement a été refusé.',
      expired: 'Votre abonnement a expiré.',
      pending: 'Votre abonnement attend encore une approbation dans Shopify.',
      test_charge_on_live_store: 'Cet abonnement de test n’est pas valable sur une boutique réelle.',
      inactive: 'Votre abonnement Autonoma n’est plus actif.',
    },
    reactivateCta: 'Réactiver {name}',
    unavailableTitle: 'Impossible de confirmer votre abonnement',
    unavailableBody: 'Shopify n’a pas répondu à temps, Autonoma ne peut donc pas encore s’ouvrir. Rien n’est perdu — réessayez dans un instant.',
    tryAgain: 'Réessayer',
    checkingAccess: 'Vérification de votre abonnement…',
    genericError: 'Une erreur s’est produite — réessayez.',
    keyNumbersTitle: 'Par mois',
    notIncluded: 'Non inclus',
    inherits: 'Tout {name}, plus :',
    customLine: 'Besoin de limites plus élevées ou de marque blanche ? Offres sur mesure pour agences et marques à gros volume —',
    customCta: 'Réserver un appel →',
    compare: 'Comparer toutes les fonctionnalités',
    close: 'Fermer',
    trustRow: 'Paiement sécurisé via Shopify · Annulation à tout moment · Changement de forfait à tout moment',
    consentTitle: 'Partagez des statistiques anonymisées pour aider à améliorer Autonoma',
    consentBody: 'Partagez des statistiques d’utilisation anonymisées et agrégées pour aider à améliorer Autonoma. Aucune donnée personnelle n’est jamais partagée. Vous pouvez changer cela à tout moment dans les Paramètres.',
    consentDefault: 'Activé par défaut (vous pouvez le désactiver à tout moment dans les Paramètres).',
    consentInfo: 'En savoir plus sur le partage de statistiques anonymisées',
    billingNote: 'La facturation est gérée en toute sécurité par Shopify et apparaît sur votre facture Shopify. En vous abonnant, vous acceptez nos',
    and: 'et notre',
    terms: 'Conditions d’utilisation',
    privacy: 'Politique de confidentialité',
    // Client fallback for backends without plan.copy.tagline / highlights
    // (the server copy in plan-copy.service.js is the source of truth).
    tiers: {
      starter: {
        tagline: 'Lancez vos premiers produits gagnants',
        highlights: ['Pages produit IA', 'Pubs image avec badges promo', 'Publireportages qui pré-vendent', 'Site de marque + logo'],
      },
      growth: {
        tagline: 'Publiez vos pubs, augmentez le panier',
        highlights: ['Publiez vos pubs sur Meta', 'Pubs feed portrait (4:5)', 'Upsells post-achat', 'App iPhone et Android'],
      },
      scale: {
        tagline: 'Vidéos, tests A/B et assistant IA',
        highlights: ['Pubs vidéo IA', 'Tests A/B avec gagnant clair', 'Assistant IA qui fait le travail', 'Support prioritaire'],
      },
      enterprise: {
        tagline: 'Pour agences et marques à gros volume',
        highlights: ['Limites maximales partout', 'De nouveaux angles chaque jour', 'Onboarding dédié', 'Support prioritaire'],
      },
    },
    keyNumbers: {
      productBuilds: 'Pages produit',
      imageAds: 'Publicités image',
      videoAds: 'Publicités vidéo',
      advertorials: 'Publireportages',
      splitTests: 'Tests A/B',
      findProductsSearches: 'Recherches de produits',
    },
    currentPlan: 'Forfait actuel',
  },
  planLimit: {
    titleReached: 'Vous avez atteint la limite de votre forfait',
    titleNotEnough: 'Il ne vous en reste pas assez ce mois-ci',
    titleNear: 'Il ne vous en reste plus beaucoup ce mois-ci',
    reached: 'Vous avez utilisé les {n} {feature} de {plan} ce mois-ci. Passez au forfait supérieur pour continuer — votre limite se réinitialise le {date}.',
    reachedBudget: 'Vous avez utilisé tout votre {feature} de {n} sur {plan} ce mois-ci. Passez au forfait supérieur pour continuer — votre limite se réinitialise le {date}.',
    notEnough: 'Il vous reste {x} {feature} ce mois-ci. Ceci en nécessite {y}. Passez au forfait supérieur pour le faire maintenant.',
    notEnoughBudget: 'Il vous reste {x} de {feature} ce mois-ci. Ceci nécessite {y}. Passez au forfait supérieur pour le faire maintenant.',
    notEnoughUnknown: 'Il vous reste {x} {feature} ce mois-ci — ce n’est pas assez pour ceci. Passez au forfait supérieur pour le faire maintenant.',
    left: 'Il vous reste {x} {feature} ce mois-ci.',
    allowance: '{n} {feature} / mois',
    allowanceBudget: '{n} {feature} / mois',
    allowanceUnlimited: '{feature} illimités',
    allowanceNone: 'Non inclus dans ce forfait',
    topTierTitle: 'Vous êtes sur notre forfait le plus élevé',
    topTierBody: 'Besoin de plus de {feature} ce mois-ci ? Nous proposons des forfaits sur mesure avec des limites plus élevées pour les agences et les marques à fort volume.',
    topTierCta: 'Contactez-nous pour un forfait sur mesure',
    referLine: 'Ou parrainez une boutique — vous recevez tous les deux des crédits bonus.',
    referCta: 'Parrainer et gagner',
    nearLimit: 'Il vous reste {n} {feature} ce mois-ci',
    nearLimitBudget: 'Il vous reste {n} de {feature} ce mois-ci',
    viewPlans: 'Voir les forfaits',
    upgraded: 'Forfait mis à niveau — vous pouvez générer maintenant.',
    loadError: 'Impossible de charger les forfaits — veuillez réessayer.',
    subscribeError: 'Impossible de lancer la mise à niveau — veuillez réessayer.',
    close: 'Fermer',
  },
  generations: {
    title: 'Créations précédentes',
    tabAll: 'Toutes',
    tabTrash: 'Corbeille',
    trashNote: 'Les éléments supprimés restent ici {n} jours — restaurez-les ou supprimez-les définitivement.',
    trashEmpty: 'La corbeille est vide.',
    empty: 'Rien de créé pour l’instant.',
    viewEdit: 'Voir / modifier',
    moveToTrash: 'Mettre à la corbeille',
    restore: 'Restaurer',
    deleteForever: 'Supprimer définitivement',
    deletedIn: 'suppression définitive {when}',
    status: {
      draft: 'Brouillon',
      published: 'Publié',
      replaced: 'Remplacé',
      trashed: 'Dans la corbeille',
    },
  },
  productDetail: {
    loading: 'Chargement du produit…',
    loadError: 'Impossible de charger ce produit',
    backToProducts: 'Retour aux produits',
    editInShopify: 'Modifier dans Shopify',
    draftNote: 'Brouillon — publiez le produit dans Shopify pour obtenir le lien de la page en ligne.',
    whatToCreate: 'Que voulez-vous créer ?',
    pagesTitle: 'Pages produit de ce produit',
    pagesEmpty: 'Aucune page produit n’a encore été créée pour ce produit.',
    pagesEmptyCta: 'Créer la page produit',
    othersTitle: 'Publireportages et packs de publicités de ce produit',
    othersEmpty: 'Aucun publireportage ni pack de publicités pour l’instant.',
    chatPrompt: 'Vous préférez simplement décrire le changement ?',
    chatCta: 'Discuter avec l’IA',
    actions: {
      ads: {
        title: 'Créer des publicités pour ce produit',
        desc: 'Visuels image et vidéo, prêts à publier sur Meta.',
      },
      images: {
        title: 'Créer des images produit',
        desc: 'De nouvelles photos produit générées par l’IA à partir de vos clichés existants.',
      },
      page: {
        title: 'Créer une page produit',
        desc: 'Une page produit à forte conversion dans le style de votre choix.',
      },
      advertorial: {
        title: 'Créer un publireportage',
        desc: 'Un article au ton éditorial qui vend — récit, recherche, liste.',
      },
      splitTest: {
        title: 'Créer un test A/B',
        desc: 'Comparez des prix, des offres ou des pages produit entre eux.',
      },
      upsell: {
        title: 'Trouver des produits d’upsell',
        desc: 'Découvrez des produits complémentaires qui augmentent votre panier moyen.',
      },
    },
  },
  flow: {
    product: 'Produit',
    build: 'Création',
    review: 'Relecture',
    publish: 'Publication',
    setup: 'Configuration',
    customise: 'Personnaliser',
    preview: 'Aperçu',
    results: 'Résultats',
  },
  findProducts: {
    title: 'Trouver des produits',
    subtitle: 'Des produits gagnants validés par de vraies dépenses publicitaires — une nouvelle sélection à chaque recherche',
    progressTitle: 'Recherche de produits gagnants',
    progressSteps: {
      scan: 'Analyse de ce qui se vend en ce moment',
      filter: 'Filtrage pour votre niche',
      rank: 'Classement des meilleures options',
    },
    cancelConfirm: 'Annuler cette recherche ?',
    cancelTitle: 'Annuler la recherche',
    noneTitle: 'Aucun produit gagnant dans cette catégorie',
    noneBody: 'Essayez une autre catégorie ou relancez la recherche — la sélection se renouvelle à chaque fois.',
  },
  ui: {
    nav: {
      menuLabel: 'Menu de navigation',
      lockedTitle: 'Passez à un forfait supérieur pour débloquer {name}',
    },
    progress: {
      done: 'Terminé !',
      anyMoment: 'D’un instant à l’autre…',
      longer: 'Un peu plus long que d’habitude…',
      minutesLeft: 'Environ {n} min restantes',
      oneMinuteLeft: 'Environ 1 min restante',
      secondsLeft: 'Environ {n} s restantes',
      leaveNote: 'Nous vous préviendrons quand ce sera terminé — vous pouvez quitter cette page.',
      cancel: 'Annuler',
    },
    errors: {
      retry: 'Réessayer',
      reload: 'Recharger la page',
      showDetails: 'Détails techniques',
      hideDetails: 'Masquer les détails',
      generic: {
        title: 'Quelque chose n’a pas fonctionné',
        body: 'Réessayez. Si le problème persiste, écrivez-nous via le bouton d’assistance.',
      },
      network: {
        title: 'Impossible de joindre Autonoma',
        body: 'Vérifiez votre connexion internet et réessayez.',
      },
      session: {
        title: 'Votre session a expiré',
        body: 'Rechargez la page pour vous reconnecter — votre travail est enregistré.',
      },
      quota: {
        title: 'Vous avez atteint la limite de votre forfait',
        body: 'Passez à un forfait supérieur ou attendez votre prochaine période de facturation pour continuer.',
      },
      notFound: {
        title: 'Nous n’avons pas trouvé cela',
        body: 'L’élément a peut-être été supprimé. Revenez en arrière et réessayez.',
      },
      busy: {
        title: 'Déjà en cours',
        body: 'C’est déjà en cours — consultez l’indicateur de progression en bas à droite.',
      },
      tooLarge: {
        title: 'Ce fichier est trop volumineux',
        body: 'Essayez un fichier plus petit.',
      },
      rateLimit: {
        title: 'Trop de requêtes',
        body: 'Patientez une minute et réessayez.',
      },
      timeout: {
        title: 'Cela a pris trop de temps',
        body: 'La requête a expiré. Réessayez — cela fonctionne généralement la deuxième fois.',
      },
      server: {
        title: 'Un problème est survenu de notre côté',
        body: 'Réessayez dans un instant.',
      },
    },
    preview: {
      label: 'Aperçu',
      device: 'Appareil d’aperçu',
      desktop: 'Ordinateur',
      mobile: 'Mobile',
      edit: 'Modifier',
      clickToEdit: 'Aperçu · cliquez pour modifier',
      editPage: 'Modifier cette page',
    },
    success: {
      whatNext: 'Que voulez-vous faire ensuite ?',
    },
    session: {
      title: 'Impossible de se connecter à votre boutique',
      body: 'Votre session Shopify ne fonctionne pas pour le moment. Une reconnexion règle généralement le problème.',
    },
    themeCode: {
      getting: 'Récupération de votre code…',
      error: 'Impossible de récupérer votre code',
    },
    editor: {
      opening: 'Ouverture de votre page…',
      archivedTitle: 'Cette page a été archivée',
      openError: 'Impossible d’ouvrir cette page',
      publishError: 'La publication n’a pas abouti',
      upToDate: '✓ En ligne · à jour',
      upToDateHint: 'Tout sur cette page est en ligne. Faites une modification et le bouton Publier réapparaît.',
      back: '← Retour',
    },
    jobs: {
      ads: 'Création des publicités',
      advertorial: 'Création de l’advertorial',
      landing_page: 'Création de la page produit',
      website: 'Création du site web',
      images: 'Création des images',
      product_build: 'Création du produit',
      split_test_build: 'Création des variantes du test',
      split_test_setup: 'Configuration du split test',
      upsell_discovery: 'Recherche d’upsells',
      upsell_build: 'Création de l’upsell',
      product_finder: 'Recherche de produits gagnants',
      edit_own_ad: 'Modification de vos publicités',
      ad_copy: 'Rédaction du texte publicitaire',
      cart_upgrade: 'Mise à niveau de votre panier',
      publish_ads: 'Publication des publicités',
      shipping_setup: 'Configuration de la livraison',
      markets_update: 'Mise à jour des marchés',
      working: 'En cours',
      updating: 'Mise à jour de votre {what}',
    },
  },
  feedback: {
    thanksTitle: 'Merci pour votre retour',
    gotIt: 'Bien reçu — ticket n°{ticket}',
    gotItBody: 'Une vraie personne de l’équipe Autonoma lit chacun de ces messages. Si nous avons besoin de précisions, nous répondrons à l’e-mail de votre boutique{email}.',
    backToDashboard: 'Retour au tableau de bord',
    sendAnother: 'En envoyer un autre',
  },
  featureRequest: {
    button: 'Demander une fonctionnalité',
    title: 'Demander une fonctionnalité',
    intro: 'Dites-nous ce que vous aimeriez qu’Autonoma fasse : nouvelles fonctionnalités, améliorations, tout ce qui vous vient. Nous lisons chaque demande.',
    label: 'Votre demande',
    placeholder: 'ex. : Permettre de programmer le lancement des publicités à une heure précise…',
    send: 'Envoyer la demande',
    tooShort: 'Dites-nous en un peu plus (au moins 10 caractères).',
    tooLong: 'Veuillez limiter votre demande à 2 000 caractères.',
    successTitle: 'Merci, votre demande a bien été envoyée.',
    successBody: 'Nous vous recontacterons si nous avons besoin de précisions.',
    reference: 'Référence n° {ticket}',
    errorGeneric: 'Impossible d’envoyer votre demande. Veuillez réessayer.',
    retry: 'Réessayer',
  },
  referAndEarn: {
    shareYourLink: 'Partagez votre lien',
  },
  // Espace « Vérifier et publier »
  review: {
    top: {
      back: 'Retour',
      breadcrumb: 'Où vous êtes',
      live: 'En ligne sur votre boutique',
      draft: 'Brouillon — pas encore en ligne',
      page: 'Page',
      part: 'Partie de la page',
      productCard: 'Fiche produit',
      landingPage: 'Page d’atterrissage',
      undo: 'Annuler',
      redo: 'Rétablir',
      history: 'Historique des versions',
      themeEditor: 'Ouvrir dans l’éditeur de thème',
      viewOnStore: 'Voir sur la boutique',
      panel: 'Afficher ou masquer le panneau d’édition',
      zoom: 'Zoom de l’aperçu',
      zoomFit: 'Ajuster',
      expand: 'Agrandir l’aperçu',
      collapse: 'Quitter le plein écran',
    },
    canvas: {
      toolbar: 'Actions pour {label}',
      editWithAi: 'Modifier avec l’IA',
      replaceImage: 'Remplacer l’image',
      moveUp: 'Monter',
      moveDown: 'Descendre',
      duplicate: 'Dupliquer',
      hide: 'Masquer',
      show: 'Afficher',
      delete: 'Supprimer',
      deleteIt: 'Supprimer',
      thisElement: 'cet élément',
      deleteConfirm: 'Supprimer « {label} » ? Vous pourrez annuler ensuite.',
      locked: 'Les boutons d’achat ne se modifient pas ici',
      updating: 'Mise à jour de {label}…',
      updatingPage: 'Mise à jour de toute la page…',
      saving: 'Enregistrement…',
      failed: 'La modification n’a pas été appliquée',
      failedOn: 'La modification de {label} n’a pas été appliquée',
      retry: 'Réessayer',
      plainFallback: 'affichage de l’aperçu simple.',
    },
    composer: {
      editing: 'Modification : {label}',
      wholePage: 'Toute la page',
      clearScope: 'Effacer la sélection',
      placeholder: 'Décrivez une modification pour toute la page…',
      placeholderScoped: 'Décrivez une modification pour {label}…',
      wholePageBusy: 'Mise à jour de toute la page — vous pouvez continuer à regarder.',
      cancelConfirm: 'Annuler cette mise à jour ?',
      cancelTitle: 'Annuler la mise à jour',
      cancelIt: 'Annuler',
    },
    prompts: {
      pagePremium: 'Un ton plus haut de gamme',
      pageShorter: 'Raccourcir le tout de 20 %',
      pageFaq: 'Ajouter une FAQ',
      pageStory: 'Rendre l’histoire plus personnelle',
      pageCta: 'Renforcer l’appel à l’action',
      headlinePunchier: 'Un titre plus percutant',
      headlineShorter: 'Le raccourcir',
      headlineBenefit: 'Commencer par le bénéfice principal',
      textTighter: 'Resserrer le texte',
      textConcrete: 'Le rendre plus concret',
      textFriendly: 'Le rendre plus chaleureux',
      buttonAction: 'Orienté vers l’action',
      buttonUrgency: 'Ajouter un peu d’urgence',
      imageLifestyle: 'Utiliser une image lifestyle',
      imageBrighter: 'Fond plus clair et plus net',
      sectionTrust: 'Ajouter des gages de confiance',
      sectionTighter: 'Resserrer le texte',
      sectionTestimonial: 'Ajouter un témoignage',
    },
    panel: {
      label: 'Panneau d’édition',
      collapse: 'Réduire le panneau',
      open: 'Panneau',
      tabs: { edit: 'Modifier', sections: 'Sections', images: 'Images', brand: 'Marque', details: 'Détails' },
    },
    edit: {
      emptyTitle: 'Rien de sélectionné',
      emptyBody: 'Cliquez sur n’importe quelle partie de la page pour la modifier.',
      inSection: 'dans {section}',
      noFields: 'Cette partie n’a pas de champ texte ou image — utilisez « Modifier avec l’IA ».',
      buttonLabel: '{label} · libellé',
      buttonLink: '{label} · lien',
      saved: 'Enregistré',
      hintEnter: 'Entrée pour enregistrer',
      hintBlur: 'Enregistré quand vous quittez le champ',
      replace: 'Remplacer',
      generate: 'Générer',
      upload: 'Importer',
      uploading: 'Import en cours…',
      uploadFailed: 'L’image n’a pas pu être importée.',
      pickImage: 'Choisir une image',
      noLibrary: 'Pas encore d’images générées pour ce produit — importez-en une.',
      useImage: 'Utiliser l’image',
      generatePrompt: 'Génère une nouvelle image pour cet emplacement — même produit, composition plus épurée. Joins une référence pour un style précis.',
    },
    sections: {
      hide: 'Masquer {label}',
      show: 'Afficher {label}',
      none: 'Aucune section trouvée sur cette page.',
      add: 'Ajouter une section',
      dragHint: 'Faites glisser la poignée pour réordonner. Les sections masquées restent dans la page mais n’apparaissent pas sur votre boutique.',
      libraryTitle: 'Ajouter une section',
      libraryHint: 'L’IA rédige la section pour cette page et la place après la partie que vous regardez.',
      placeAfter: 'Place-la juste après la section « {section} ».',
      library: {
        benefits: { name: 'Bénéfices', desc: 'Trois à quatre bénéfices avec icônes.', instruction: 'Ajoute une section bénéfices avec 3 à 4 bénéfices concrets, chacun avec un titre court, une phrase et une icône simple.' },
        testimonials: { name: 'Témoignages', desc: 'Avis clients avec prénoms et notes.', instruction: 'Ajoute une section témoignages avec trois avis crédibles, prénoms, villes et notes 5 étoiles.' },
        faq: { name: 'FAQ', desc: 'Cinq questions fréquentes avant achat.', instruction: 'Ajoute une FAQ avec cinq vraies questions avant achat et des réponses concrètes et rassurantes.' },
        gallery: { name: 'Galerie d’images', desc: 'Une grille des images existantes.', instruction: 'Ajoute une galerie utilisant uniquement les images déjà présentes sur la page, dans une grille épurée.' },
        comparison: { name: 'Tableau comparatif', desc: 'Nous face aux alternatives habituelles.', instruction: 'Ajoute un tableau comparatif : ce produit face aux alternatives classiques, 4 à 5 lignes, avec coches et croix.' },
        howItWorks: { name: 'Comment ça marche', desc: 'Trois étapes numérotées.', instruction: 'Ajoute une section « Comment ça marche » en trois étapes numérotées, chacune avec un titre court et une phrase.' },
        guarantee: { name: 'Garantie', desc: 'Satisfait ou remboursé et notes de livraison.', instruction: 'Ajoute une section garantie : promesse satisfait ou remboursé, livraison et retours en mots simples, avec un badge.' },
        cta: { name: 'Appel à l’action', desc: 'Une bannière de clôture avec bouton.', instruction: 'Ajoute une bannière finale d’appel à l’action avec un titre fort, une ligne de réassurance et un bouton vers le bouton d’achat ou le produit existant.' },
      },
    },
    brand: {
      noLogo: 'Aucun logo n’a encore été généré pour ce site.',
      colours: 'Couleurs de marque',
      fonts: 'Polices',
      change: 'Changer',
      noColours: 'Les couleurs de marque viennent de votre thème.',
      headingFont: 'Titres',
      bodyFont: 'Texte',
      themeDefault: 'Valeur du thème',
    },
    details: {
      product: 'Produit',
      title: 'Titre',
      price: 'Prix',
      compareAt: 'Prix barré',
      none: 'Aucun',
      status: 'Statut',
      productHint: 'Le titre, le prix et le prix barré viennent de Shopify. Modifiez-les là-bas — la page se met à jour à la publication.',
      editInShopify: 'Modifier le produit dans Shopify',
      advertorial: 'Publireportage',
      headline: 'Titre',
      linkedProduct: 'Produit lié',
      ctaOk: 'L’appel à l’action renvoie vers {product}.',
      ctaOther: 'L’appel à l’action renvoie vers un autre produit.',
      ctaMissing: 'Aucun lien vers le produit — ajoutez-en un pour que les lecteurs puissent acheter.',
      openProduct: 'Ouvrir le produit',
    },
    pages: {
      publishesWithSite: 'Cette page est créée lors de la publication du site.',
    },
    coach: {
      step: '{n} sur {total}',
      clickTitle: 'Cliquez sur une partie pour la modifier',
      clickBody: 'Survolez pour voir ce qui est modifiable, cliquez pour sélectionner, puis utilisez la barre flottante ou le panneau de droite.',
      composerTitle: 'Ou décrivez une modification ici',
      composerBody: 'Écrivez ce que vous voulez avec vos mots. Avec une sélection, la modification reste dedans ; sinon elle s’applique à toute la page.',
      publishTitle: 'Publiez quand ça vous convient',
      publishBody: 'Rien n’est en ligne avant d’appuyer sur Publier. Chaque modification est enregistrée et peut être annulée.',
      skip: 'Passer',
      gotIt: 'Compris',
    },
    bar: {
      publish: 'Publier sur ma boutique',
      update: 'Mettre à jour la page en ligne',
      publishing: 'Publication…',
      saveDraft: 'Enregistrer le brouillon',
      checking: 'Vérification…',
      review: 'Vérifier',
      oneIssue: '1 problème bloque la publication',
      nIssues: '{n} problèmes bloquent la publication',
      oneSuggestion: '1 suggestion',
      nSuggestions: '{n} suggestions',
      blockedTooltip: 'La publication est bloquée',
      blockedTooltipAction: 'Cliquez pour vérifier et corriger.',
      blockedBy: 'bloqué par {n} problème(s)',
      whyBlocked: 'Pourquoi ne puis-je pas publier ? Voir les problèmes',
      savedJustNow: 'Enregistré à l’instant',
      savedAgo: 'Enregistré il y a {n} min',
      allSaved: 'Toutes les modifications sont enregistrées',
    },
  },
};

export default fr;
